<div class="top-loader" *ngIf="isLoading"></div>
<div class="row">
  <div class="col-md-4">
    <div class="fs-4 fw-semibold mb-0">{{'contact' | translate}}</div>
  </div>
  <div class="col-md-12 my-4">
    <div class="row">
      <div class="col-xl-8 col-lg-12 col-md-12 mb-4">
        <div class="card border-1 rounded-3 bg-white p-0">
          <div class="card-header rounded-top-3 fs-5 px-2 py-3 fw-semibold bg-white border-bottom">
            {{'personalinformation' | translate}}
          </div>
          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-4">
                  <label class="fw-semibold fs-6 mb-2">{{ 'fullname' | translate }}*</label>
                  <input pInputText formControlName="fullName" [placeholder]="'fullname' | translate"
                    [ngClass]="{'ng-dirty': contactForm.get('fullName')?.invalid && contactForm.get('fullName')?.touched}" />
                </div>
                <div class="col-md-6 mb-4">
                  <div class="flex-column d-flex contact">
                    <label class="fw-semibold fs-6 mb-2">{{ 'providerphonenumber' | translate }}*</label>
                    <p-inputMask formControlName="phoneNumber" [placeholder]="'phonenumber' | translate"
                      mask="(999) 999-9999"
                      [ngClass]="{'ng-dirty': contactForm.get('phoneNumber')?.invalid && contactForm.get('phoneNumber')?.touched}"></p-inputMask>
                  </div>
                </div>
                <div class="col-md-12 mb-4">
                  <label class="fw-semibold fs-6 mb-2">{{ 'provideremail' | translate }}*</label>
                  <input pInputText formControlName="email" [placeholder]="'email' | translate"
                    [ngClass]="{'ng-dirty': contactForm.get('email')?.invalid && contactForm.get('email')?.touched}" />
                </div>
                <div class="col-md-12 mb-4">
                  <div class="d-flex flex-column message">
                    <label class="fw-semibold fs-6 mb-2">{{ 'message' | translate }}*</label>
                    <textarea 
                      pInputTextarea 
                      formControlName="messageBody" 
                      rows="5" 
                      cols="30"
                      [placeholder]="'enteryourmessage' | translate"
                      [ngClass]="{'error-border': (contactFormSubmitted && contactForm.get('messageBody')?.invalid)}">
                    </textarea>
                  </div>
                  
                </div>
                <div class="col-md-12">
                  <div class="d-flex justify-content-end save align-items-center gap-3">
                    <p-button type="submit">
                      <ng-container *ngIf="!isLoading">
                        {{ 'send' | translate }}
                      </ng-container>
                      <ng-container *ngIf="isLoading">
                        <mat-spinner diameter="20"></mat-spinner>
                      </ng-container>
                    </p-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12 col-md-12 mb-4">
        <div class="card border-1 rounded-3 bg-white p-0 h-100">
          <div class="card-header rounded-top-3 fs-5 px-2 py-3 fw-semibold bg-white border-bottom">
            {{'contactdetails' | translate}}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 mb-4">
                <div class="d-flex flex-column">
                  <label for="" class="fw-semibold fs-6 mb-2">{{'contactnumber' | translate}}</label>
                  <div *ngFor="let phonenumber of this.assuredData?.phoneNumbers">
                    <a class="text-muted text-decoration-none" [href]="'tel:' + phonenumber.trim()">{{phonenumber || '-'}}</a>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="d-flex flex-column">
                  <label for="" class="fw-semibold fs-6 mb-2">{{'emailaddress' | translate}}</label>
                  <div *ngFor="let email of this.assuredData?.emails">
                    <span class="text-muted">{{email || '-'}}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mb-4">
                <div class="d-flex flex-column">
                  <label for="" class="fw-semibold fs-6 mb-2">{{'address' | translate}}</label>
                  <span class="text-muted">{{this.assuredData?.address || '-'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>